import { ValidatorPosition } from '../../position/validator-position';
export const config = {
    value: 'minItems',
    position: [
        ValidatorPosition.form,
        ValidatorPosition.formDialog,
        ValidatorPosition.cnArraySubAreaCard,
    ],
};
